import { FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { FormBlockerHelpAction } from '../../FormBlockerHelpAction/FormBlockerHelpAction'
import { DecoratorFn, getElementType } from '../FormBlockerElementDecorator'

const unset = -1

const getFirstBestTextElementIndex = (elements: FormBlockerElement[]) => {
  return elements.reduce((acc, current, index) => {
    if (
      getElementType(current) === 'text_element' &&
      getElementType(elements[index + 1]) !== 'text_element' &&
      // we only want to set the first best text element index once
      acc === unset
    ) {
      return index
    }
    return acc
  }, unset)
}

export const addHelpAction: DecoratorFn = ({ elements, index, children }) => {
  const firstBestTextElementIndex = getFirstBestTextElementIndex(elements)

  if (index === firstBestTextElementIndex) {
    return (
      <>
        {children}
        <FormBlockerHelpAction />
      </>
    )
  }

  return null
}
